import { AnyObject } from 'types';
import { Node } from 'slate';

export type ScrollNodeIntoView = (node: CustomNode) => void;

type CustomNode = Node & AnyObject;

export default function scrollNodeIntoView(editor): ScrollNodeIntoView {
  return function (node: CustomNode): void {
    try {
      const element = document.getElementById(node.annotationId);

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    } catch (error) {
      console.log('----------------- scrollNodeIntoView ----------------');
    }
  };
}
